const Input = (props) => (
  <input
    className="registration-input"
    { ...props }
  />
)

export default Input